import TakeOff from "@/assets/images/takeoff.png";
import Cost from "@/assets/images/cost.png";
import SystemDesign from "@/assets/images/system_design.png";

export const takeoffServices = [
  {
    id: 1,
    title: 'Proposal Building',
    description: 'We provide detailed material quantity surveys for Low Voltage (ELV) systems, helping integrators, contractors, and consultants clearly understand the materials required for each project. By reviewing architectural drawings, system layouts, and project specifications, we extract accurate quantities for cables, devices, conduits, equipment, and accessories.\n\nOur structured reports allow your team to build proposals faster, reduce estimation errors, and ensure every component required for the project is properly accounted for.',
    image: TakeOff,
    icon: 'ri-file-list-3-line',
    tags: ['Quantity Surveying', 'ELV Material Takeoffs', 'Proposal Support', 'System Planning'],
    features: []
  },
  {
    id: 2,
    title: 'Cost Estimation / Labor Hours',
    description: 'Our trade-specific quantity extraction service focuses on precise measurements tailored to individual disciplines. Whether the requirement is cable lengths for structured cabling, device counts for security systems, or fixture quantities for AV and automation systems, we isolate and measure only the elements relevant to your scope of work.\n\nThis focused approach eliminates ambiguity, simplifies procurement, and ensures subcontractors and project managers order only the materials required for their specific trade.',
    image: Cost,
    icon: 'ri-calculator-line',
    tags: ['Trade-Specific Takeoffs', 'MEP Quantification', 'Subcontractor Support', 'Area Measurements'],
    features: []
  },
  {
    id: 3,
    title: 'System Design',
    description: 'To ensure complete transparency and verification, we provide clear visual documentation alongside our quantity reports. Each project includes high-resolution, color-coded PDF drawings that highlight every measured component directly on the plans.\n\nThese visual markups create an easy audit trail, allowing project managers, estimators, and engineers to quickly verify quantities against the original blueprints with confidence.',
    image: SystemDesign,
    icon: 'ri-ruler-2-line',
    tags: ['Color-Coded Markups', 'Visual Auditing', 'Takeoff Verification', 'Blueprint Coordination'],
    features: []
  }
];

